export const GET_DEVICES = 'get-devices';
export const GET_DEVICES_RESULT = `${GET_DEVICES}/result`;
export const GET_DEVICES_ERROR = `${GET_DEVICES}/error`;
